import script from "./setPartnership.vue?vue&type=script&setup=true&lang=js"
export * from "./setPartnership.vue?vue&type=script&setup=true&lang=js"

import "./setPartnership.vue?vue&type=style&index=0&id=62ab180e&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62ab180e"]])

export default __exports__